/* collins-pages.js: the Work index and the case pages (COLLINS-CASE.md). No library; native scroll, as COLLINS.
     - the case's picture row drags with momentum on a desktop pointer (the home's card-row numbers); a phone wraps it
     - "All N pictures" opens the gallery sheet: a modal <dialog> that slides up in 450 ms; the close button, Escape
       and the dimmed strip above it slide it back down; focus returns to the control that opened it
     - a case film plays only while on screen, its sources attached from here so reduced motion downloads nothing,
       and the viewer's pause always wins
     - the related deck: the next case in front, one neighbour peeking on each side; a drag, a swipe, the arrow keys,
       a click on a neighbour or focus on a card brings that case forward; a click on the front card opens it
     - prompt 4 (21 Oct 2026): on the Work shelf, ONE card plays its reel (the STOP J reel that opens on the card's own
       picture) while it is under a mouse pointer or has keyboard focus, on a laptop only; leaving it stops it. Nine
       reels on one dark shelf would be a wall of motion, so nothing plays on its own; a phone keeps the pictures.
       Reduced motion and Save-Data: no reel. The video is made on first use, so the shelf downloads nothing until then
     - prompt 5 (24 Oct 2026): where a case's ladder (the printed pieces at one scale) is wider than its panel, a phone,
       it takes a tab stop and a name so a keyboard can scroll it (axe scrollable-region-focusable, found on the live
       site too at STOP N); where it fits, it takes none
   Everything it adds is removed on pagehide and shopify:section:unload. */
(function () {
  'use strict';
  var d = document, w = window;
  var mqReduce = w.matchMedia('(prefers-reduced-motion: reduce)');
  var mqFine = w.matchMedia('(hover: hover) and (pointer: fine)');
  var S = null;

  function on(t, type, fn, opt) { t.addEventListener(type, fn, opt); S.off.push(function () { t.removeEventListener(type, fn, opt); }); }

  /* ---------- a horizontal row dragged by a mouse, then gliding on (a 550 px drag travels about 690) ---------- */
  function drag(track) {
    var down = false, captured = false, id = 0, x0 = 0, s0 = 0, moved = 0, vx = 0, lastX = 0, lastT = 0, raf = 0;
    var glide = function () { vx *= 0.93; track.scrollLeft -= vx; if (Math.abs(vx) > 0.35) raf = w.requestAnimationFrame(glide); };
    on(track, 'dragstart', function (e) { e.preventDefault(); });
    on(track, 'pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || track.scrollWidth <= track.clientWidth + 2) return;
      w.cancelAnimationFrame(raf);
      down = true; captured = false; id = e.pointerId; moved = 0; vx = 0;
      x0 = lastX = e.clientX; s0 = track.scrollLeft; lastT = performance.now();
    });
    on(track, 'pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - x0;
      moved = Math.max(moved, Math.abs(dx));
      if (moved > 6 && !captured) { captured = true; track.setPointerCapture(id); track.classList.add('is-dragging'); }
      if (!captured) return;
      track.scrollLeft = s0 - dx;
      var t = performance.now(), dt = Math.max(1, t - lastT);
      vx = 0.8 * ((e.clientX - lastX) * (16.7 / dt)) + 0.2 * vx;
      lastX = e.clientX; lastT = t;
    });
    var up = function () {
      if (!down) return;
      down = false;
      if (captured) {
        try { track.releasePointerCapture(id); } catch (err) {}
        w.setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
        if (!mqReduce.matches && performance.now() - lastT < 80) raf = w.requestAnimationFrame(glide);
      }
    };
    on(track, 'pointerup', up);
    on(track, 'pointercancel', up);
    on(track, 'click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    S.off.push(function () { w.cancelAnimationFrame(raf); track.classList.remove('is-dragging'); });
  }

  /* ---------- the gallery sheet ---------- */
  function sheet(btn) {
    var dlg = d.getElementById(btn.getAttribute('data-cl-open'));
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var timer = 0;
    var open = function () {
      if (dlg.open) return;
      w.clearTimeout(timer);
      dlg.showModal();
      dlg.scrollTop = 0;
      w.requestAnimationFrame(function () { w.requestAnimationFrame(function () { dlg.classList.add('is-in'); }); });
    };
    var shut = function () {
      if (!dlg.open) return;
      dlg.classList.remove('is-in');
      w.clearTimeout(timer);
      timer = w.setTimeout(function () { if (dlg.open) dlg.close(); }, mqReduce.matches ? 0 : 460);
    };
    on(btn, 'click', open);
    on(dlg, 'cancel', function (e) { e.preventDefault(); shut(); });
    on(dlg, 'close', function () { dlg.classList.remove('is-in'); btn.focus({ preventScroll: true }); });
    on(dlg, 'click', function (e) { if (e.target === dlg && e.clientY < dlg.getBoundingClientRect().top) shut(); });   /* the dimmed strip above the sheet */
    Array.prototype.forEach.call(dlg.querySelectorAll('[data-cl-close]'), function (c) { on(c, 'click', shut); });
    S.off.push(function () { w.clearTimeout(timer); dlg.classList.remove('is-in'); if (dlg.open) dlg.close(); });
  }

  /* ---------- a case film: on screen only, the viewer's pause wins ---------- */
  function film(fig) {
    var v = fig.querySelector('video'), b = fig.querySelector('[data-cl-film-btn]');
    if (!v || !b) return;
    var userPaused = false;
    var attach = function () {
      var srcs = v.querySelectorAll('source[data-src]');
      if (!srcs.length) return;
      Array.prototype.forEach.call(srcs, function (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); });
      v.preload = 'auto'; v.load();
    };
    var play = function () { attach(); var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    var label = function () { b.textContent = v.paused ? 'Play the film' : 'Pause the film'; };
    on(v, 'playing', function () { v.classList.add('is-on'); label(); });
    on(v, 'pause', label);
    on(b, 'click', function () { if (v.paused) { userPaused = false; play(); } else { userPaused = true; v.pause(); } label(); });
    b.hidden = false;
    /* prompt 4: sized once to the longer label, so "Play the film" and "Pause the film" never change its width (a layout shift) */
    b.textContent = 'Pause the film'; b.style.minWidth = (b.offsetWidth / parseFloat(w.getComputedStyle(b).fontSize)).toFixed(3) + 'em';
    label();
    if (!('IntersectionObserver' in w)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) { if (!v.paused) v.pause(); }
        else if (!userPaused && !mqReduce.matches) play();
      });
    }, { threshold: 0.25 });
    io.observe(fig);
    S.off.push(function () { io.disconnect(); if (!v.paused) v.pause(); });
  }

  /* ---------- the Work shelf: one reel at a time, under the pointer or with keyboard focus (prompt 4) ---------- */
  function shelf() {
    var tiles = Array.prototype.slice.call(d.querySelectorAll('.cl-tile[data-cl-reel]'));
    if (!tiles.length) return;
    var wide = w.matchMedia('(min-width: 768px)');
    var save = !!(navigator.connection && navigator.connection.saveData);
    var cur = null;
    var stop = function (t) {
      var v = t.querySelector('video');
      if (v) { v.classList.remove('is-on'); if (!v.paused) v.pause(); }
      if (cur === t) cur = null;
    };
    var start = function (t) {
      if (mqReduce.matches || save || !mqFine.matches || !wide.matches) return;
      if (cur && cur !== t) stop(cur);
      cur = t;
      var box = t.querySelector('.cl-pic'), v = box && box.querySelector('video');
      if (!box) return;
      if (!v) {
        v = d.createElement('video');
        v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'auto';
        v.setAttribute('aria-hidden', 'true'); v.setAttribute('tabindex', '-1'); v.setAttribute('disablepictureinpicture', '');
        v.src = t.getAttribute('data-cl-reel');
        box.appendChild(v);
        on(v, 'playing', function () { if (cur === t) v.classList.add('is-on'); else v.pause(); });
      }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    };
    tiles.forEach(function (t) {
      on(t, 'pointerenter', function (e) { if (e.pointerType === 'mouse') start(t); });
      on(t, 'pointerleave', function () { stop(t); });
      on(t, 'focusin', function () { start(t); });
      on(t, 'focusout', function () { stop(t); });
    });
    S.off.push(function () { tiles.forEach(function (t) { var v = t.querySelector('.cl-pic video'); if (v) { try { v.pause(); } catch (e) {} v.remove(); } }); cur = null; });
  }

  function ladder(el) {
    var fit = function () {
      if (el.scrollWidth > el.clientWidth + 1) {
        el.setAttribute('tabindex', '0'); el.setAttribute('role', 'region'); el.setAttribute('aria-label', 'The pieces at one scale, scroll sideways');
      } else { el.removeAttribute('tabindex'); el.removeAttribute('role'); el.removeAttribute('aria-label'); }
    };
    fit(); on(w, 'resize', fit);
    S.off.push(function () { el.removeAttribute('tabindex'); el.removeAttribute('role'); el.removeAttribute('aria-label'); });
  }

  /* ---------- the related deck ---------- */
  function deck(root) {
    var list = root.querySelector('.cl-deck-list');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cl-deck-card]'));
    var nameEl = root.querySelector('[data-cl-deck-name]');
    var n = cards.length;
    if (!list || n < 2) return;
    var cur = 0;
    root.classList.add('is-deck');
    if (nameEl) nameEl.hidden = false;
    var ratio = function (c) { return parseFloat(c.getAttribute('data-r')) || 1; };
    var layout = function () {
      /* H: the cards' own height (--cl-deck-h); a front card wider than the column shrinks to fit, whole */
      var H = cards[0].offsetHeight || list.clientHeight, W = list.clientWidth, peek = W < 600 ? 24 : 46;   /* prompt 4: 24 px, a side card is a 24 px tap target on a phone */
      var sf = Math.min(1, (W - 2 * peek) / (ratio(cards[cur]) * H)), fw = ratio(cards[cur]) * H * sf;
      list.style.height = Math.round(H * sf) + 'px';
      cards.forEach(function (c, i) {
        var k = ((i - cur) % n + n) % n, dd = k <= n / 2 ? k : k - n;
        var r = ratio(c), s = sf, x = 0, o = 1, z = 1;
        if (dd === 0) { z = 3; }
        else if (Math.abs(dd) === 1) {
          /* a neighbour peeks 46 px past the front card's edge (COLLINS: 306 x 466 behind 400 x 533), never wider than that */
          s = Math.min(0.874 * sf, (fw + peek) / (r * H));
          x = (dd > 0 ? 1 : -1) * (fw / 2 + peek - (r * H * s) / 2);
          z = 2;
        } else { s = Math.min(0.717 * sf, fw / (r * H)); o = 0; z = 1; }
        c.style.setProperty('--y', (-(H * (1 - sf)) / 2).toFixed(1) + 'px');
        c.style.setProperty('--x', x.toFixed(1) + 'px');
        c.style.setProperty('--s', s.toFixed(4));
        c.style.setProperty('--o', String(o));
        c.style.zIndex = String(z);
        c.classList.toggle('is-front', dd === 0);
        var a = c.querySelector('a');
        if (a) a.tabIndex = (o === 0) ? -1 : 0;
      });
      if (nameEl) {
        var f = cards[cur], note = f.getAttribute('data-note');
        nameEl.textContent = f.getAttribute('data-name') || '';
        if (note) { var sp = d.createElement('span'); sp.className = 'cl-note'; sp.textContent = ' ' + note; nameEl.appendChild(sp); }
      }
    };
    var go = function (i) { cur = ((i % n) + n) % n; layout(); };
    layout();
    /* prompt 4: the deck class is set in the markup before the first paint (cl-case-body); the cards take their places
       without a transition, then move with one */
    w.requestAnimationFrame(function () { w.requestAnimationFrame(function () { root.classList.remove('is-settling'); }); });

    cards.forEach(function (c, i) {
      var a = c.querySelector('a');
      if (!a) return;
      on(a, 'click', function (e) { if (i !== cur || moved > 8) { e.preventDefault(); if (moved <= 8) go(i); } });
      on(a, 'focus', function () { if (i !== cur) go(i); });
    });
    on(root, 'keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); var a = cards[cur].querySelector('a'); if (a) a.focus({ preventScroll: true }); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); var b = cards[cur].querySelector('a'); if (b) b.focus({ preventScroll: true }); }
    });
    /* drag or swipe: past 40 px the next or previous case comes forward */
    var down = false, x0 = 0, y0 = 0, moved = 0, horiz = null;
    on(list, 'dragstart', function (e) { e.preventDefault(); });
    on(list, 'pointerdown', function (e) { if (e.button !== 0) return; down = true; x0 = e.clientX; y0 = e.clientY; moved = 0; horiz = null; });
    on(list, 'pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (horiz === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) horiz = Math.abs(dx) > Math.abs(dy);
      if (horiz) moved = Math.max(moved, Math.abs(dx));
    });
    var up = function (e) {
      if (!down) return;
      down = false;
      if (horiz && e && typeof e.clientX === 'number') { var dx = e.clientX - x0; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); }
      w.setTimeout(function () { moved = 0; }, 0);
    };
    on(list, 'pointerup', up);
    on(list, 'pointercancel', function () { down = false; moved = 0; });
    on(w, 'resize', layout);
    S.off.push(function () {
      root.classList.remove('is-deck');
      list.style.height = '';
      cards.forEach(function (c) { c.style.removeProperty('--x'); c.style.removeProperty('--y'); c.style.removeProperty('--s'); c.style.removeProperty('--o'); c.style.zIndex = ''; c.classList.remove('is-front'); var a = c.querySelector('a'); if (a) a.removeAttribute('tabindex'); });
      if (nameEl) nameEl.hidden = true;
    });
  }

  function init() {
    if (S || !d.querySelector('[data-cl-page]')) return;
    S = { off: [] };
    if (mqFine.matches) Array.prototype.forEach.call(d.querySelectorAll('[data-cl-strip]'), drag);
    Array.prototype.forEach.call(d.querySelectorAll('[data-cl-open]'), sheet);
    Array.prototype.forEach.call(d.querySelectorAll('[data-cl-film]'), film);
    Array.prototype.forEach.call(d.querySelectorAll('[data-cl-deck]'), deck);
    Array.prototype.forEach.call(d.querySelectorAll('.cl-ladder'), ladder);
    shelf();
  }
  function destroy() {
    if (!S) return;
    var off = S.off; S = null;
    for (var i = off.length - 1; i >= 0; i--) { try { off[i](); } catch (e) {} }
  }

  var ours = function (e) { return e.target && e.target.querySelector && e.target.querySelector('[data-cl-page]'); };
  d.addEventListener('shopify:section:unload', function (e) { if (ours(e)) destroy(); });
  d.addEventListener('shopify:section:load', function (e) { if (ours(e)) { destroy(); init(); } });
  w.addEventListener('pagehide', destroy);
  w.addEventListener('pageshow', function (e) { if (e.persisted) init(); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
